import React from 'react';
import moment from 'moment-timezone';
import Select from 'components/UI/Select';
import { TableFilter } from 'components/UI/Table';
import { DateFilter } from './DateFilter';

// Компонент фильтра даты
export const DateFilterComponent = React.memo(
	({ filter, setFilter }: { filter: TableFilter; setFilter: (filter: TableFilter) => void }) => (
		<DateFilter filter={filter} setFilter={setFilter} />
	),
);

// Функция для создания фильтра даты
export const createDateFilterFunction = (filter: TableFilter, setFilter: (filter: TableFilter) => void) => () =>
	<DateFilterComponent filter={filter} setFilter={setFilter} />;

// Универсальная функция для форматирования времени (для IBreach)
export const createTimeFormatter = (useMoscowTime = false) =>
	React.useCallback((row: any) => {
		const formattedTime = useMoscowTime
			? moment.tz(row.createdAt, 'Europe/Moscow').format('DD.MM.YY HH:mm')
			: moment(row.createdAt).format('DD.MM.YY HH:mm');

		return (
			<div>
				<span>{formattedTime}</span>
			</div>
		);
	}, []);

// Форматтер для действия (приход/уход)
export const createActionFormatter = () =>
	React.useCallback((row: any) => {
		return (
			<div>
				<span>{row?.open === true && 'Приход'}</span>
				<span>{row?.open === false && 'Уход'}</span>
			</div>
		);
	}, []);

// Универсальная функция для форматирования менеджеров (для breach с checkin)
export const createBreachManagerFormatter = (managerField: 'regional_manager' | 'ao_manager') =>
	React.useCallback((row: any) => {
		return (
			<div>
				<span>{row.checkin?.store?.[managerField]}</span>
			</div>
		);
	}, []);

// Универсальная функция для форматирования менеджеров (для session с store)
export const createSessionManagerFormatter = (managerField: 'regional_manager' | 'ao_manager') =>
	React.useCallback((row: any) => {
		return <div>{row.store?.[managerField]}</div>;
	}, []);

// Универсальная функция для создания фильтров менеджеров
export const createManagerFilterFunction = (
	filter: TableFilter,
	setFilter: (filter: TableFilter) => void,
	options: any[],
	filterKey: 'regional_manager' | 'ao_manager',
	width: string = '100px',
) =>
	React.useCallback(() => {
		const handleChange = (newValue: any): void => {
			setFilter({ ...filter, [filterKey]: newValue });
		};

		return <Select onChange={handleChange} options={options} isClearable width={width} />;
	}, [filter, setFilter, options]);
